import React from 'react';
import './MetricCard.css';

interface MetricCardProps {
  title: string;
  value: string | number;
  trend?: string;
  icon: string;
  trendUp?: boolean;
}

const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  trend,
  icon,
  trendUp = true,
}) => {
  return (
    <div className="metric-card">
      <div className="metric-content">
        <div className="metric-info">
          <h3 className="metric-title">{title}</h3>
          <div className="metric-value">{value}</div>
          {trend && (
            <div className={`metric-trend ${trendUp ? 'trend-up' : 'trend-down'}`}>
              <span className="trend-arrow">{trendUp ? '↑' : '↓'}</span>
              {trend}
            </div>
          )}
        </div>
        <div className="metric-icon">{icon}</div>
      </div>
    </div>
  );
};

export default MetricCard;

